var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoLocations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 157,
    viewBox: "0 0 176 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5312 111.187C86.8978 111.187 90.4375 107.879 90.4375 103.797C90.4375 99.7151 86.8978 96.4062 82.5312 96.4062C78.1647 96.4062 74.625 99.7151 74.625 103.797C74.625 107.879 78.1647 111.187 82.5312 111.187Z",
    stroke: "#188AEC",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.25 88.3457L70.3125 80.9643L60.25 73.9375",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.812 88.3457L94.75 80.9643L104.812 73.9375",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1874 31.9062C105.544 34.221 112.932 41.061 115.508 49.769",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.375 9.06249C128.757 9.06249 130.688 7.25764 130.688 5.03125C130.688 2.80485 128.757 1 126.375 1C123.993 1 122.062 2.80485 122.062 5.03125C122.062 7.25764 123.993 9.06249 126.375 9.06249Z",
    stroke: "#188AEC",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.938 30.5625C173.319 30.5625 175.25 28.7576 175.25 26.5312C175.25 24.3049 173.319 22.5 170.938 22.5C168.556 22.5 166.625 24.3049 166.625 26.5312C166.625 28.7576 168.556 30.5625 170.938 30.5625Z",
    fill: "#188AEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.525 19.4883L149.54 30.7196M149.723 19.4883L137.708 30.7196L149.723 19.4883Z",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89258 43.457L10.5176 51.5195M10.5176 43.457L1.89258 51.5195L10.5176 43.457Z",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 34.5937C23.8192 34.5937 25.75 32.7889 25.75 30.5625C25.75 28.3361 23.8192 26.5312 21.4375 26.5312C19.0558 26.5312 17.125 28.3361 17.125 30.5625C17.125 32.7889 19.0558 34.5937 21.4375 34.5937Z",
    fill: "#188AEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 156C109.75 128.6 136 104.065 136 73.8C136 43.5348 112.495 19 83.5 19C54.5051 19 31 43.5348 31 73.8C31 104.065 57.25 128.6 83.5 156Z",
    stroke: "#188AEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocations);
export default __webpack_public_path__ + "static/media/noLocations.897595f7927be01c16f92fd61e9d8de5.svg";
export { ForwardRef as ReactComponent };